var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HotelsMap',{staticClass:"flex-grow-1",attrs:{"event":_vm.event,"bundle-products":_vm.bundleProducts,"bus-events-parent":_vm.busEvents,"is-visible":_vm.isVisible,"uniform-hotel-card":""}})}
var staticRenderFns = []

export { render, staticRenderFns }